
import { RichText } from '@wordpress/block-editor';
import BlockContext from "../context/blockContext";
import { useContext } from "@wordpress/element";
import SectionItemContext from "../context/sectionItemContext";

function Tools() {
    const { updateField, scrollToSection, toggleReferencePanel } = useContext(BlockContext);
    const { item, index, itemIndex } = useContext(SectionItemContext);
  return (
    <ul
        className="cv-tools"
        onClick={() => scrollToSection("section8")}
        onClick={toggleReferencePanel}
    >
        <RichText
        tagName="li"
        className="tool-item"
        value={item.name}
        onChange={(value) => updateField(index, "name", value, itemIndex)}
        />
    </ul>
  )
}

export default Tools
